import { defineMessages } from './define'

/* Per-person module access (ac.*) and printing bills, receipts and the day end (pr.print*). */

export default defineMessages({
  en: {
    'ac.title': 'Access',
    'ac.note': 'Starts from the role. Switch areas on or off for this person.',
    'ac.adminAll': 'Administrators have every area.',
    'ac.changed': 'changed for this person',
    'ac.none': 'None',
    'ac.noBilling': 'Taking payments is not part of your access. Ask the administrator.',
    'ac.m.billing': 'Billing',
    'ac.d.billing': 'Bills, desk payments, day end',
    'ac.m.reports': 'Reports',
    'ac.d.reports': 'Visits, money, doctors, diagnoses',
    'ac.m.stock.view': 'See stock',
    'ac.d.stock.view': 'Stock list and stock reports',
    'ac.m.stock.manage': 'Manage stock',
    'ac.d.stock.manage': 'Stock in, counts, use, import',
    'ac.m.stock.ledger': 'Stock ledger',
    'ac.d.stock.ledger': 'Purchases against tests, with costs',
    'ac.m.lab.recipes': 'Lab item lists',
    'ac.d.lab.recipes': 'Set the items each test uses',
    'ac.m.lab.complete': 'Mark lab tests done',
    'ac.d.lab.complete': 'Record the items a test used',
    'pr.printReceipt': 'Print receipt',
    'pr.printBill': 'Print bill',
    'pr.printDayEnd': 'Print day-end summary',
  },
  hi: {
    'ac.title': 'पहुँच',
    'ac.note': 'भूमिका से शुरू। इस व्यक्ति के लिए हिस्से चालू या बंद करें।',
    'ac.adminAll': 'प्रशासक के पास सभी हिस्से हैं।',
    'ac.changed': 'इस व्यक्ति के लिए बदला',
    'ac.none': 'कोई नहीं',
    'ac.noBilling': 'भुगतान लेना आपकी पहुँच में नहीं है। प्रशासक से पूछें।',
    'ac.m.billing': 'बिलिंग',
    'ac.d.billing': 'बिल, काउंटर भुगतान, दिन का हिसाब',
    'ac.m.reports': 'रिपोर्ट',
    'ac.d.reports': 'विज़िट, पैसा, डॉक्टर, निदान',
    'ac.m.stock.view': 'स्टॉक देखें',
    'ac.d.stock.view': 'स्टॉक सूची और स्टॉक रिपोर्ट',
    'ac.m.stock.manage': 'स्टॉक संभालें',
    'ac.d.stock.manage': 'स्टॉक आना, गिनती, उपयोग, आयात',
    'ac.m.stock.ledger': 'स्टॉक खाता',
    'ac.d.stock.ledger': 'जाँचों के मुकाबले ख़रीद, लागत सहित',
    'ac.m.lab.recipes': 'लैब सामान सूची',
    'ac.d.lab.recipes': 'हर जाँच में लगने वाला सामान तय करें',
    'ac.m.lab.complete': 'लैब जाँच पूरी करें',
    'ac.d.lab.complete': 'जाँच में लगा सामान दर्ज करें',
    'pr.printReceipt': 'रसीद प्रिंट करें',
    'pr.printBill': 'बिल प्रिंट करें',
    'pr.printDayEnd': 'दिन का हिसाब प्रिंट करें',
  },
  mr: {
    'ac.title': 'प्रवेश',
    'ac.note': 'भूमिकेपासून सुरू. या व्यक्तीसाठी भाग चालू किंवा बंद करा.',
    'ac.adminAll': 'प्रशासकाकडे सर्व भाग आहेत.',
    'ac.changed': 'या व्यक्तीसाठी बदलले',
    'ac.none': 'काहीही नाही',
    'ac.noBilling': 'पैसे घेणे तुमच्या प्रवेशात नाही. प्रशासकाला विचारा.',
    'ac.m.billing': 'बिलिंग',
    'ac.d.billing': 'बिले, काउंटर पेमेंट, दिवसअखेर',
    'ac.m.reports': 'अहवाल',
    'ac.d.reports': 'भेटी, पैसे, डॉक्टर, निदान',
    'ac.m.stock.view': 'स्टॉक पाहा',
    'ac.d.stock.view': 'स्टॉक यादी आणि स्टॉक अहवाल',
    'ac.m.stock.manage': 'स्टॉक सांभाळा',
    'ac.d.stock.manage': 'स्टॉक आवक, मोजणी, वापर, आयात',
    'ac.m.stock.ledger': 'स्टॉक खातेवही',
    'ac.d.stock.ledger': 'चाचण्यांच्या तुलनेत खरेदी, खर्चासह',
    'ac.m.lab.recipes': 'लॅब वस्तू यादी',
    'ac.d.lab.recipes': 'प्रत्येक चाचणीसाठी लागणाऱ्या वस्तू ठरवा',
    'ac.m.lab.complete': 'लॅब चाचणी पूर्ण करा',
    'ac.d.lab.complete': 'चाचणीसाठी वापरलेल्या वस्तू नोंदवा',
    'pr.printReceipt': 'पावती प्रिंट करा',
    'pr.printBill': 'बिल प्रिंट करा',
    'pr.printDayEnd': 'दिवसअखेर सारांश प्रिंट करा',
  },
  or: {
    'ac.title': 'ପ୍ରବେଶ',
    'ac.note': 'ଭୂମିକାରୁ ଆରମ୍ଭ। ଏହି ବ୍ୟକ୍ତିଙ୍କ ପାଇଁ ଅଂଶ ଚାଲୁ ବା ବନ୍ଦ କରନ୍ତୁ।',
    'ac.adminAll': 'ପ୍ରଶାସକଙ୍କ ପାଖରେ ସମସ୍ତ ଅଂଶ ଅଛି।',
    'ac.changed': 'ଏହି ବ୍ୟକ୍ତିଙ୍କ ପାଇଁ ବଦଳାଗଲା',
    'ac.none': 'କିଛି ନାହିଁ',
    'ac.noBilling': 'ଟଙ୍କା ନେବା ଆପଣଙ୍କ ପ୍ରବେଶରେ ନାହିଁ। ପ୍ରଶାସକଙ୍କୁ ପଚାରନ୍ତୁ।',
    'ac.m.billing': 'ବିଲିଂ',
    'ac.d.billing': 'ବିଲ, କାଉଣ୍ଟର ପେମେଣ୍ଟ, ଦିନ ଶେଷ',
    'ac.m.reports': 'ରିପୋର୍ଟ',
    'ac.d.reports': 'ଭିଜିଟ, ଟଙ୍କା, ଡାକ୍ତର, ରୋଗ ନିର୍ଣ୍ଣୟ',
    'ac.m.stock.view': 'ଷ୍ଟକ ଦେଖନ୍ତୁ',
    'ac.d.stock.view': 'ଷ୍ଟକ ତାଲିକା ଓ ଷ୍ଟକ ରିପୋର୍ଟ',
    'ac.m.stock.manage': 'ଷ୍ଟକ ପରିଚାଳନା',
    'ac.d.stock.manage': 'ଷ୍ଟକ ଆସିବା, ଗଣନା, ବ୍ୟବହାର, ଆମଦାନୀ',
    'ac.m.stock.ledger': 'ଷ୍ଟକ ଖାତା',
    'ac.d.stock.ledger': 'ପରୀକ୍ଷା ତୁଳନାରେ କିଣା, ଖର୍ଚ୍ଚ ସହ',
    'ac.m.lab.recipes': 'ଲ୍ୟାବ ସାମଗ୍ରୀ ତାଲିକା',
    'ac.d.lab.recipes': 'ପ୍ରତି ପରୀକ୍ଷାରେ ଲାଗୁଥିବା ସାମଗ୍ରୀ ସ୍ଥିର କରନ୍ତୁ',
    'ac.m.lab.complete': 'ଲ୍ୟାବ ପରୀକ୍ଷା ସମାପ୍ତ',
    'ac.d.lab.complete': 'ପରୀକ୍ଷାରେ ବ୍ୟବହୃତ ସାମଗ୍ରୀ ଲେଖନ୍ତୁ',
    'pr.printReceipt': 'ରସିଦ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'pr.printBill': 'ବିଲ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'pr.printDayEnd': 'ଦିନ ଶେଷ ସାରାଂଶ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
  },
})
